import {graphql} from "@/V2/helpers/shopify";

const ORDER_QUERY_WITH_LINE_ITEMS = `
  query getOrders($cursor: String) {
    orders(first: 50, after: $cursor, query: "financial_status:paid fulfillment_status:unfulfilled") {
      pageInfo {
        hasNextPage
      }
      edges {
        cursor
        node {
          id
          email
          name
          shippingAddress {
            name
            address1
            address2
            city
            province
            zip
            country
            phone
          }
          subtotalPriceSet {
            shopMoney { amount currencyCode }
            presentmentMoney { amount currencyCode }
          }
          totalPriceSet {
            shopMoney { amount currencyCode }
            presentmentMoney { amount currencyCode }
          }
          totalShippingPriceSet {
            shopMoney { amount currencyCode }
            presentmentMoney { amount currencyCode }
          }
          totalTaxSet {
            shopMoney { amount currencyCode }
            presentmentMoney { amount currencyCode }
          }
          totalDiscountsSet {
            shopMoney { amount currencyCode }
            presentmentMoney { amount currencyCode }
          }
          lineItems(first: 50) {
            pageInfo {
              hasNextPage
            }
            edges {
              cursor
              node {
                title
                quantity
                sku
                variant {
                  id
                  title
                }
                originalUnitPriceSet {
                  shopMoney {
                    amount
                    currencyCode
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

const LINE_ITEM_PAGINATION_QUERY = `
  query getMoreLineItems($orderId: ID!, $cursor: String) {
    order(id: $orderId) {
      lineItems(first: 50, after: $cursor) {
        pageInfo {
          hasNextPage
        }
        edges {
          cursor
          node {
            title
            quantity
            sku
            variant {
              id
              title
            }
            originalUnitPriceSet {
              shopMoney {
                amount
                currencyCode
              }
            }
          }
        }
      }
    }
  }
`;

const fetchAllLineItemsForOrder = async (orderId: string, existingLineItems: any[]): Promise<any[]> => {
  let allLineItems = [...existingLineItems];
  let cursor = existingLineItems.length ? existingLineItems[existingLineItems.length - 1].cursor : null;
  let hasNextPage = existingLineItems.length > 0;

  while (hasNextPage) {
    const response = await graphql({
      data: {
        graphql: {
            query: LINE_ITEM_PAGINATION_QUERY,
            variables: { orderId, cursor },
        }
      },
    });

    const lineItems = response.data.data.order.lineItems;
    const edges = lineItems.edges;
    allLineItems.push(...edges);
    hasNextPage = lineItems.pageInfo.hasNextPage;
    cursor = edges.length ? edges[edges.length - 1].cursor : null;
  }

  return allLineItems;
};

export default {
  namespaced: true,

  state: () => ({
    orders: [],
  }),

  mutations: {
    setOrders(state: any, orders: any[]) {
      state.orders = orders;
    },
  },
  getters: {
    orders: state => {
      return state.orders
    },
  },
  actions: {
    async init({ commit }) {
      let allOrders: any[] = [];
      let cursor: string | null = null;
      let hasNextPage = true;

      while (hasNextPage) {
        const response = await graphql({
          data: {
            graphql: {
                query: ORDER_QUERY_WITH_LINE_ITEMS,
                variables: { cursor },
            }
          },
        });

        const orders = response.data.data.orders;
        for (const edge of orders.edges) {
          const order = edge.node;

          const initialLineItems = order.lineItems.edges;
          const hasMoreLineItems = order.lineItems.pageInfo.hasNextPage;

          let fullLineItems = initialLineItems;
          if (hasMoreLineItems) {
            fullLineItems = await fetchAllLineItemsForOrder(order.id, initialLineItems);
          }

          order.lineItems = fullLineItems.map((edge: any) => edge.node);
          allOrders.push(order);
        }

        hasNextPage = orders.pageInfo.hasNextPage;
        cursor = orders.edges.length ? orders.edges[orders.edges.length - 1].cursor : null;
      }

      commit("setOrders", allOrders);
    },
  },
};
